import { ThemeColor } from '@/enums'
import { useFormContext, useFormItem } from '@/providers'
import { themeColorFrom } from '@/utils'
import { Datepicker } from '@surein/ui'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import { getError } from './helpers'

const StyledMessage = styled.p<{ color: ThemeColor }>`
  cursor: inherit;
  white-space: pre-line;
  line-height: 140%;
  font-weight: 700;
  font-size: 12px;
  color: ${themeColorFrom(prop('color'))};
`

interface Props {
  name: string
  label?: string
  disabled?: boolean
  prefixIcon?: React.ElementType
  suffixIcon?: React.ElementType
  infoMessage?: string
  showErrorMessage?: boolean
  showValidCheck?: boolean
  validateOnChange?: boolean
  max?: Date
  min?: Date
  showCalendar?: boolean
}

export const FormDatepicker = ({
  name,
  label,
  disabled,
  prefixIcon,
  suffixIcon,
  infoMessage,
  showErrorMessage = true,
  showValidCheck = false,
  validateOnChange = false,
  ...props
}: Props) => {
  const { validateField } = useFormContext()
  const [touched, setIsTouched] = useState(false)
  const { value, onChange, error } = useFormItem(name)
  const errorMsg = getError(error) as string | null

  useEffect(() => {}, [value])

  useEffect(() => {
    if (touched && validateOnChange && value) validateField(name)
  }, [validateOnChange, touched, value])

  const hasErrorMessage = !!(errorMsg && showErrorMessage)
  const isSuccessful = showValidCheck && touched && !error && value

  return (
    <div className="flex flex-col gap-2">
      <Datepicker
        {...(props as any)} // Type assertion to bypass TypeScript checks as id is not a prop of Datepicker
        id={name}
        isErrored={Boolean(error)}
        isSuccessful={isSuccessful}
        label={label}
        name={name}
        onBlur={() => touched && validateField(name)}
        onChange={onChange}
        onFocus={() => setIsTouched(true)}
        prefixIcon={prefixIcon}
        suffixIcon={suffixIcon}
        value={value}
        {...props}
      />
      {hasErrorMessage && (
        <StyledMessage color={ThemeColor.danger2}>{errorMsg}</StyledMessage>
      )}
      {infoMessage && !hasErrorMessage && (
        <StyledMessage color={ThemeColor.b50}>{infoMessage}</StyledMessage>
      )}
    </div>
  )
}
